import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
import IllustrationTabPanelPreview from "@project/components/IllustrationTabPanel/IllustrationTabPanelPreview";
export const IllustrationTabItem = {
    label: "Onglet illustré",
    key: "items",
    type: ContentsCustomTypes.ILLUSTRATION_TAB_ITEM,
    value: "",
    children: [
        {
            label: "Icône de l'onglet (SVG)",
            key: "icon",
            type: ContentsTypes.FILE_IMAGE,
            value: "",
        },
        {
            label: "Libellé de l'onglet",
            key: "label",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Couleur de la bordure",
            key: "borderColor",
            type: ContentsTypes.COLOR,
            value: "#19d3c5",
        },
        {
            label: "Illustration (SVG)",
            key: "illustration",
            type: ContentsTypes.FILE_IMAGE,
            value: "",
        },
        {
            key: "dynamicPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            label: "",
        },
    ],
};
export const IllustrationTabs = {
    label: "Onglets illustrés",
    type: ContentsCustomTypes.ILLUSTRATION_TABS,
    Preview: IllustrationTabPanelPreview,
    icon: "list-alt",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Orientation",
            key: "orientation",
            type: ContentsTypes.RADIO_GROUP,
            value: "vertical",
            options: [
                { label: "Vertical", value: "vertical" },
                { label: "Horizontal", value: "horizontal" },
            ],
        },
        {
            key: "dynamicList",
            type: ContentsTypes.DYNAMIC_LIST,
            value: "",
            children: [
                {
                    key: "contentType",
                    children: [IllustrationTabItem],
                    value: ContentsCustomTypes.ILLUSTRATION_TAB_ITEM,
                },
            ],
        },
    ],
};
